import { Box } from "@chakra-ui/react";
import { genders } from "../../../../services/constants";
import { AppUser } from "../../../../services/Dtos";
import { ChangeEvent } from "react";
import TextInput from "../../../CustomUi/TextInput";
import SelectInput from "../../../CustomUi/SelectInput";

interface Props {
  onUserChange: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  appUserFormState: AppUser;
  errors: { [key: string]: string };
}

export default function AppUserForm({
  appUserFormState,
  onUserChange,
  errors,
}: Props) {
  const genderOptions = genders.map((g) => ({
    label: g.name,
    value: g.value.toString(),
  }));

  return (
    <Box>
      <TextInput
        label="First Name"
        name="firstName"
        type="text"
        value={appUserFormState?.firstName || ""}
        onChange={onUserChange}
        placeholder="First name"
        error={errors.firstName}
        invalid={!!errors.firstName}
      />
      <TextInput
        label="Last Name"
        name="lastName"
        type="text"
        value={appUserFormState?.lastName || ""}
        onChange={onUserChange}
        placeholder="Last name"
        error={errors.lastName}
        invalid={!!errors.lastName}
      />
      <TextInput
        label="Email"
        name="email"
        type="email"
        value={appUserFormState?.email || ""}
        onChange={onUserChange}
        placeholder="Email"
        error={errors.email}
        invalid={!!errors.email}
      />
      <SelectInput
        label="Gender"
        name="gender"
        value={appUserFormState?.gender.toString()}
        onChange={onUserChange}
        collection={genderOptions}
        placeholder="Select gender"
        error={errors.gender}
        invalid={!!errors.gender}
      />
    </Box>
  );
}
